import React, { Component } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import Constant from "../../Constant";
import BarLoader from "react-bar-loader";

import ImagesUploader from "react-images-uploader";

export default class AssignCourse extends Component {
  state = {
    loading: true,
    data: [],
    columns: [
      {
        name: "User",
        selector: "fullName",
        sortable: true,
      },
      {
        name: "Email",
        selector: "email",
        sortable: true,
      },
      {
        name: "Options",
        selector: "id",
        sortable: true,
        cell: (row) => (
          <div className="d-flex">
            {
              row.isEnrolled === true
                ?
                <button
                  class="btn btn-danger shadow-sm mx-1"
                  id={row.id}
                  onClick={this.onRemoveEnrollUser}
                >Remove</button>
                :
                <button
                  class="btn shadow-sm mx-1 btn-primary"
                  id={row.id}
                  onClick={this.onEnrollUser}
                >Enroll</button>
            }
          </div>
        ),
      },
    ],
  };
  componentDidMount() {
    this.setState({ courseId: this.props.match.params.course_id });
    this.getTopics();
  }
  getTopics = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append(
      "Authorization",
      localStorage.getItem("livelms_auth")
    );

    var urlencoded = new URLSearchParams();
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("courseId", this.props.match.params.course_id);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/course/courseLearners", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        var data = result.data[0].users;
        var courseName = result.data[0].name;
        for (let i = 0; i < data.length; i++) {
          console.log(data[i]);
          var str = data[i].createdAt;
          var date = new Date(str);
          data[i].fullName = data[i].firstName + " " + data[i].lastName;
          console.log(data[i]);
          data[i].createdAt = `${date.getUTCDate()}-${
            date.getUTCMonth() + 1
            }-${date.getUTCFullYear()}`;
          data[i].updatedAt = `${date.getUTCDate()}-${
            date.getUTCMonth() + 1
            }-${date.getUTCFullYear()}`;
        }
        this.setState({ data: data, courseName: courseName, loading: false });
      })
      .catch((error) => console.log("error", error));
  };
  onEnrollUser = (event) => {
    console.log(event.target.id);
    var userId = event.target.id;
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append(
      "Authorization",
      localStorage.getItem("livelms_auth")
    );

    var urlencoded = new URLSearchParams();
    urlencoded.append("userId", userId);
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("courseId", this.props.match.params.course_id);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/course/enroll", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // document.location.reload();
        if (result.status === true) {
          this.getTopics()
        }
      })
      .catch((error) => console.log("error", error));
  }
  onRemoveEnrollUser = (event) => {
    console.log(event.target.id);
    var userId = event.target.id;
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append(
      "Authorization",
      localStorage.getItem("livelms_auth")
    );

    var urlencoded = new URLSearchParams();
    urlencoded.append("userId", userId);
    urlencoded.append("siteId", localStorage.getItem("lms_site_id"));
    urlencoded.append("courseId", this.props.match.params.course_id);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getAPI() + "/course/unEnroll", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // document.location.reload();
        if (result.status === true) {
          this.getTopics()
        }
      })
      .catch((error) => console.log("error", error));
  }
  render() {
    return (
      <div>
        <div className="py-3">
          <div className="container border shadow-sm p-0 bg-white">
            <div className="header bg-primary text-white">
              <div className="row m-0">
                <div className="col-md-8 p-3 d-flex align-items-center">
                  <h5 className="m-0">
                    <Link to="/admin/dashboard">Home</Link> /{" "}
                    <Link to="/admin/courses">Courses</Link> /{" "}
                    {this.state.courseName} /{" Enroll Users"}
                  </h5>
                </div>
              </div>
            </div>

            <div className="users-container p-2">
              {this.state.loading == true ? (
                <div className="container p-5">
                  <div className="col-md-3 mx-auto">
                    <BarLoader color="#33cabb" height="4" />
                  </div>
                </div>
              ) : (
                  <DataTable
                    noHeader={true}
                    columns={this.state.columns}
                    data={this.state.data}
                    theme="solarized"
                    pagination={true}
                    noDataComponent={
                      <div className="m-3">No Users Available</div>
                    }
                  />
                )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
